import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { BookingData, CMS, SecurityData } from '../shared/index';
import { CoreComponentAjaxUtils, getAjaxhelper, isNull } from '../utils/index';

export interface MyRewardProps extends BaseComponentProps {
    lang: string;
    user: SecurityData.ApplicationUser;
    user_login: boolean;
}
export interface MyRewardState extends BaseComponentState { 
    count: number;
    reviews: CMS.Review[];
    page: number;
    total: number;
    requesting: boolean;
}

export class MyReward extends BaseComponent<MyRewardProps, MyRewardState> {

    constructor(props: MyRewardProps) {
        super(props); 
        this.state = {
            count: 0,
            reviews: [],
            page: 0,
            total: 0,
            requesting: true
        };
    } 

    componentDidMount() {
        this.getReview();
    }
    
    componentDidUpdate(prevProps: MyRewardProps, prevState: MyRewardState) {
		if (prevProps.user !== this.props.user) {
			this.getReview();
		}
    }
    
    getReview: ( ) => any = ( ) => {
		/*let incModel: CommonCommunicationData.IncludeModelParam[] = [{
			modelName: 'Hotel'
        }];
        */
		new CoreComponentAjaxUtils(getAjaxhelper()).getPagedDataWithPromise({
			modelName: 'Review',
			pageSize: this.state.count,
			page: this.state.page,
			orders: [['createdAt', 'desc']],
			where: {
				custId: this.props.user.id  
			},
			eraseAuditTrail: true,
			// includeModels: incModel
		}).then(
			d => { 
				this.setStateHelper(
					st => {
						let datas: BookingData.BookingHeader[] = d.rows as any;
						if (!isNull(datas)) { 
							st.reviews = datas;
							st.total = d.count!;
						} 
						st.requesting = false; 
					}
				);
			}).catch((exc) => { console.error('error: ', exc); });
	}

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        return (
            <div className="col-md-9" style={{ minHeight: 500 }}>
                <h1>My Reword</h1>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/my-account/MyReward.tsx